import type { clientConfig } from "../../server/src/clientConfig";

export const compiledClientConfig = {
	spog: false,
	basePrefix: "",
	// no-dd-sa:typescript-code-style/ban-ts-comment
	// @ts-ignore
	...(window.clientEnv as typeof clientConfig)
};
